'use client'

import { FC } from 'react'

import styles from './styles.module.css'
import { ILoadingProps } from './types'

const Loading: FC<ILoadingProps> = ({ className, variant = 'primary' }) => {
  return (
    <div className="relative w-[24px] h-24px]">
      <span
        className={`${styles.loadingWrapper}
        ${variant === 'primary' ? styles.loadingWrapperPrimary : styles.loadingWrapperSecondary}
        ${className}
      `}
      />
      <span
        className={`${styles.loadingContent}
        ${variant === 'primary' ? styles.loadingContentPrimary : styles.loadingContentSecondary}`}
      />
    </div>
  )
}

export default Loading
